import tr from "./tr.json";
import en from "./en.json";

export const dictionaryList = { en, tr };

export const languageOptions = {
  en: "English",
  tr: "Türkçe",
};
